import { render, staticRenderFns } from "./CardFeatureText.vue?vue&type=template&id=1860e4bb&scoped=true"
import script from "./CardFeatureText.vue?vue&type=script&lang=js"
export * from "./CardFeatureText.vue?vue&type=script&lang=js"
import style0 from "./CardFeatureText.vue?vue&type=style&index=0&id=1860e4bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1860e4bb",
  null
  
)

export default component.exports